<footer>
  <div class="container">
    <div class="d-flex justify-content-end align-items-center">
      <p>&copy;&nbsp;Commissionerate of Municipal Administration</p>
    </div>
  </div>
</footer>
